var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('MainView'),(_vm.type == 1)?_c('Function'):_vm._e(),(_vm.type == 0)?_c('Tishi'):_vm._e(),_c('O2vr'),_c('Play',{attrs:{"floor":'Rectangle294579029',"ios":_vm.flag}}),(_vm.type == 1)?_c('Client'):_vm._e(),(_vm.type == 1)?_c('O2im'):_vm._e(),_c('Box'),_c('Zhuchiren')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }